// @spec POL-STR-007
// Policy Hub documents page route

import { createFileRoute } from '@tanstack/react-router';

import { DocumentsPage } from '@/features/documents';

export const Route = createFileRoute('/_authenticated/policies/documents')({
  component: PoliciesDocumentsPage,
});

function PoliciesDocumentsPage() {
  return (
    <div className="p-8">
      <DocumentsPage />
    </div>
  );
}
